module.exports = __webpack_public_path__ + "img/elbrus.556db39e.jpg";